export const urls = {
  GET_TIER_BY_ID:
    "https://tr1.api.riotgames.com/lol/league/v4/entries/by-summoner",
  GET_MATCHES_BY_ACC_ID:
    "https://tr1.api.riotgames.com/lol/match/v4/matchlists/by-account",
  GET_EACH_MATCH:
    "https://tr1.api.riotgames.com/lol/match/v4/matches",
  GET_CHAMPİONS:
    "https://ddragon.leagueoflegends.com/cdn/11.2.1/data/en_US/champion.json",
  API_KEY: "RGAPI-520f8a28-28dc-4110-a16d-22e889f45628",
};
